const Lessions = () => {
  return <section className="w-full bg-white py-12 sm:py-16 md:py-20 lg:py-28">
            <div className="container mx-auto px-3 sm:px-4 md:px-6 lg:px-8">
                <div className="mx-auto max-w-7xl lg:hidden">
                    <div className="flex flex-col gap-6 sm:gap-8">
                        <div>
                            <p className="font-mulish text-xs sm:text-sm font-semibold uppercase tracking-[0.3em] text-amber-800">
                                Weisheit der Ernährung lernen
                            </p>
                            <h2 className="mt-4 sm:mt-5 font-serif text-xl sm:text-2xl md:text-3xl font-light leading-tight tracking-tight text-[#1f4d3c]">
                                Ayurveda-Kochkurs – traditionelle Weisheit in Ihr Zuhause bringen
                            </h2>
                        </div>

                        <div className="relative aspect-[4/5] overflow-hidden rounded-[16px] sm:rounded-[24px] bg-transparent shadow-none">
                            <img
    src="/images/Hiru/public_images/680A0954-Enhanced-NR-Edit-copy-2.webp"
    alt="Demonstration der Ayurveda-Küche"
    className="h-full w-full object-contain object-center" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="lazy" />
                        </div>

                        <div className="space-y-4 sm:space-y-6 font-mulish text-sm sm:text-base md:text-base lg:text-lg leading-7 sm:leading-8 text-gray-700">
                            <p>
                                Im Resort können Sie jederzeit an den regelmäßig stattfindenden Kochdemonstrationen und Kursen teilnehmen. Dabei lernen Sie die traditionellen ayurvedischen Kochmethoden kennen und erhalten hilfreiche Tipps für einfache, alltägliche Gerichte mit verschiedenen Gewürzen. Der Grundansatz ist bewusst einfach, sodass Sie die Inspiration auch nach Ihrer Rückkehr zu Hause leicht in Ihre tägliche Ernährung integrieren können.
                            </p>
                            <p>
                                Fragen oder Wünsche? Dann wenden Sie sich jederzeit gerne an das Küchen-Team von Hilt.
                            </p>
                        </div>

                        <div className="pt-2 sm:pt-4">
                            <h3 className="font-serif text-lg sm:text-2xl md:text-2xl font-semibold text-[#1f4d3c]">
                                Letzte Tipps für eine gesündere Zukunft
                            </h3>
                            <div className="mt-3 sm:mt-4 space-y-4 sm:space-y-5 font-mulish text-sm sm:text-base md:text-base lg:text-lg leading-7 sm:leading-8 text-gray-700">
                                <p>
                                    Am Ende Ihres Aufenthalts erhalten Sie eine abschließende Beratung, bei der Ihnen ein individueller Ernährungsplan und eine Lebensmittelübersicht für Ihren persönlichen Bedarf erstellt werden.
                                </p>
                                <p>
                                    Auch nach Beendigung Ihrer Behandlung in Sri Lanka begleitet Sie der Arzt weiterhin dabei, eine passende Ernährung für Ihren Körperbau und Ihren Zustand zu finden. Wenn Sie diese Empfehlungen auch nach Ihrer Rückkehr langsam in Ihren Alltag integrieren, werden Sie langfristig spürbare und nachhaltige Vorteile für Körper und Geist erleben – selbst Wochen oder Monate später.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mx-auto hidden max-w-7xl items-start gap-8 lg:gap-10 xl:gap-16 lg:grid lg:grid-cols-[0.9fr_1.1fr]">
                    <div className="order-1 lg:sticky lg:top-28">
                        <div className="relative aspect-[4/5] overflow-hidden rounded-[24px] bg-transparent shadow-none">
                            <img
    src="/images/Hiru/public_images/680A0954-Enhanced-NR-Edit-copy-2.webp"
    alt="Demonstration der Ayurveda-Küche"
    className="h-full w-full object-contain object-center" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="lazy" />
                        </div>
                    </div>

                    <div className="order-2">
                        <p className="font-mulish text-sm font-semibold uppercase tracking-[0.3em] text-amber-800">
                            Weisheit der Ernährung lernen
                        </p>
                        <h2 className="mt-5 font-serif text-3xl font-light leading-tight tracking-tight text-[#1f4d3c] sm:text-4xl lg:text-5xl">
                            Ayurveda-Kochkurs – traditionelle Weisheit in Ihr Zuhause bringen
                        </h2>

                        <div className="mt-8 space-y-6 font-mulish text-base leading-8 text-gray-700 sm:text-lg">
                            <p>
                                Im Resort können Sie jederzeit an den regelmäßig stattfindenden Kochdemonstrationen und Kursen teilnehmen. Dabei lernen Sie die traditionellen ayurvedischen Kochmethoden kennen und erhalten hilfreiche Tipps für einfache, alltägliche Gerichte mit verschiedenen Gewürzen. Der Grundansatz ist bewusst einfach, sodass Sie die Inspiration auch nach Ihrer Rückkehr zu Hause leicht in Ihre tägliche Ernährung integrieren können.
                            </p>
                            <p>
                                Fragen oder Wünsche? Dann wenden Sie sich jederzeit gerne an das Küchen-Team von Hilt.
                            </p>
                        </div>

                        <div className="mt-10 pt-7">
                            <h3 className="font-serif text-2xl font-semibold text-[#1f4d3c] sm:text-3xl">
                                Letzte Tipps für eine gesündere Zukunft
                            </h3>
                            <div className="mt-5 space-y-5 font-mulish text-base leading-8 text-gray-700 sm:text-lg">
                                <p>
                                    Am Ende Ihres Aufenthalts erhalten Sie eine abschließende Beratung, bei der Ihnen ein individueller Ernährungsplan und eine Lebensmittelübersicht für Ihren persönlichen Bedarf erstellt werden.
                                </p>
                                <p>
                                    Auch nach Beendigung Ihrer Behandlung in Sri Lanka begleitet Sie der Arzt weiterhin dabei, eine passende Ernährung für Ihren Körperbau und Ihren Zustand zu finden. Wenn Sie diese Empfehlungen auch nach Ihrer Rückkehr langsam in Ihren Alltag integrieren, werden Sie langfristig spürbare und nachhaltige Vorteile für Körper und Geist erleben – selbst Wochen oder Monate später.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>;
};
export default Lessions;
